import { create } from 'zustand'
import type { User } from '../types/user'

type State = {
  users: Array<User>
  add: (user: User) => void
  update: (user: User) => void
  remove: (_id: string) => void
  setUsers: (users: Array<User>) => void
}

const initial: Array<User> = []

export const useUsersStore = create<State>((set, get) => ({
  users: initial,
  add: (user) => {
    set({ users: [...get().users, user] })
  },
  update: (user) => {
    set({
      users: get().users.map((usr) => (usr._id === user._id ? user : usr)),
    })
  },
  remove: (_id) => {
    set({ users: get().users.filter((usr) => usr._id !== _id) })
  },
  setUsers: (users) => {
    set({ users })
  },
}))
